<div [caTruncate]="300" class="d-flex" [attr.data-uit]="'file-item-' + index" [ngClass]="{ 'name-disabled': !isFileNameClickable(item) }">
    <!-- Main file or folder item -->
    <div [caTruncate]="300" class="text-truncate d-flex align-items-center flex-grow-1 file-item-container" (click)="openItem(item, $event)">
        <!-- File status icon -->
        <ca-file-status-icon
            *ngIf="showFileStatus && isFilesStatusShown && !isFolder"
            [convertStatus]="isCziConversionEnabled ? item.convertStatus : 'Success'"
            [validationStatus]="item.validationStatus"
            [shouldShowValidationStatus]="!!datasetId"
            [isSegmentation]="isSegmentation"
        ></ca-file-status-icon>
        <!-- File or folder icon -->
        <ca-icon
            [name]="isFolder ? 'folder' : 'file'"
            size="s"
            class="me-2 ms-1"
            [ngClass]="{
                'ca-color-icon-error': hasError,
                'ms-1': hasError,
                'ms-3': isRemoveInvalidFilesDialog,
            }"
        ></ca-icon>
        <!-- File name with conditional styling -->
        <div [ngClass]="textClasses" [caTruncate]="100" class="text-truncate">
            <ng-container *ngIf="item.convertStatus === 'Active'; else nameLink">
                <span class="text-muted text-truncate">{{ item.name }}</span>
            </ng-container>
            <ng-template #nameLink>
                <span
                    [ngClass]="{
                        'text-danger':
                            isFilesStatusShown &&
                            ((item.convertStatus && item.convertStatus !== 'Active' && item.convertStatus !== 'Success') ||
                                (item.validationStatus && item.validationStatus !== 'PendingValidation' && item.validationStatus !== 'Valid')),
                    }"
                    data-uit="file-name"
                    ngbTooltip="{{ item.name }}"
                    placement="bottom-start"
                    class="text-truncate"
                >
                    {{ item.name }}
                </span>
            </ng-template>
        </div>
    </div>
    <!-- Optional additional content -->
    <ng-content></ng-content>
</div>
